import { Spinner } from '@optools/components/loading/spinner';
import { Toggle, ToggleProps } from '@optools/components/ui/toggle';
import { cn } from '@optools/components/ui/utils';

interface MappingViewButtonProps extends ToggleProps {
  isActive: boolean;
  loading: boolean;
}
export const MappingViewButton = ({
  className,
  isActive,
  loading,
  pressed,
  ref,
  ...props
}: MappingViewButtonProps) => {
  return (
    <Toggle
      ref={ref}
      className={cn(
        'relative flex h-28 w-full items-center rounded-lg border-primary p-4 text-base font-normal transition-colors hover:bg-primary/10 data-[state=on]:text-accent dark:data-[state=on]:text-accent-foreground',
        {
          'border-blue-600 data-[state=on]:bg-blue-600': pressed && !isActive,
          'border-green-600 data-[state=on]:bg-green-600 dark:border-green-700 dark:data-[state=on]:bg-green-700':
            pressed && isActive,
        },
        className,
      )}
      pressed={pressed}
      variant="outline"
      {...props}>
      {props.children}
      {loading && isActive && <Spinner className="absolute top-2 right-2" variant="loader" />}
    </Toggle>
  );
};
